<template>
<p class="text-center p-4 text-gray-600 pt-10">
   Created with love by
   <a
      class="border-b text-blue-500"
      href="https://icrewsystems.com/en"
      target="_blank"
      >icrewsystems</a
      >, on Vue.js and Tailwind.css   
</p>

</template>
<script>
export default {
  name: 'Footer'
}
</script>
